import React from "react";
import { useTranslation } from "react-i18next";

const roleLabels = {
  father: { en: "Father", ar: "الأب" },
  mother: { en: "Mother", ar: "الأم" },
  sibling: { en: "Sibling or Cousin", ar: "أخ / أخت أو ابن/ابنة عم/خال" },
  friend: { en: "Relative", ar: "أحد الأقارب" },
};

const statusLabels = {
  pending: { en: "Pending", ar: "بانتظار التحقق" },
  accepted: { en: "Approved", ar: "تم التأكيد" },
  rejected: { en: "Rejected", ar: "تم الرفض" },
};

const TaskViewModal = ({ task, onClose }) => {
  const { t, i18n } = useTranslation();

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
      <div className="bg-white rounded-lg shadow-lg p-6 w-[90%] max-w-lg relative animate-fadeIn">
        <button
          onClick={onClose}
          className="absolute top-2 right-3 text-gray-700 text-xl font-bold"
        >
          &times;
        </button>

        <h2 className="text-lg font-bold mb-3">
          {t("taskmodal_stage")} {task.stage + 1} - {t("episode")}{" "}
          {task.episode}
        </h2>

        <p className="text-sm text-gray-700 mb-2">
          <strong>{t("taskmodal_task")}:</strong>{" "}
          {i18n.language === "ar" ? task.task : task.task_en}
        </p>

        <div className="mt-4">
          <h4 className="text-md font-semibold mb-1">{t("verifiers")}</h4>
          <ul className="list-disc pl-5 text-sm text-gray-800">
            {task.verifiers?.map((v, i) => {
              const roleLabel = roleLabels[v.role]?.[i18n.language] || v.role;
              const statusLabel =
                statusLabels[v.status]?.[i18n.language] || v.status;

              return (
                <li key={i}>
                  <div>
                    <span className="font-bold">{v.name}</span>{" "}
                    <span className="text-gray-600">
                      ({v.email || v.phone})
                    </span>
                  </div>
                  <div className="text-xs text-gray-500 ml-2">
                    {t("role")}: {roleLabel} | {t("status")}: {statusLabel}
                  </div>
                </li>
              );
            })}
          </ul>
        </div>

        <div className="mt-4 text-sm text-gray-600">
          {t("submitted_at")}: {new Date(task.createdAt).toLocaleString()}
        </div>
      </div>
    </div>
  );
};

export default TaskViewModal;
